import useDocumentTitle from "hooks/useDocumentTitle";
import { useForm, FormProvider } from "react-hook-form";

import { Aliases } from "./components/Aliases";
import { Header } from "./components/Header";
import { MedtelIds } from "./components/MedtelIds";
import { MemberIdPrefixes } from "./components/MemberIdPrefixes";
import { Parent } from "./components/Parent";
import { PayerName } from "./components/PayerName";
import { PverifyId } from "./components/PverifyId";
import { SubmitPayer } from "./components/SubmitPayer";

export function CreatePayerPage() {
  useDocumentTitle("Create Payer");

  const methods = useForm({
    defaultValues: {
      name: "",
      type: "Commercial",
      parent: [],
      pverifyId: [],
      aliases: [],
      memberIdPrefixes: [],
    },
  });
  return (
    <FormProvider {...methods}>
      <Header isPayer />
      <PayerName />
      <Parent />
      <PverifyId />
      <MedtelIds />
      <Aliases />
      <MemberIdPrefixes />
      <SubmitPayer />
    </FormProvider>
  );
}
